/**
 * @author Ariel
 * @date 2021-12-29
 */
import React from 'react'
import {component_tool} from '../../../../../tool';

let { WizButton} = component_tool
let componentName = 'shortVideoScreen'

const columns = (_handleLook) => {
 return [
  {
    name: 'id',
    formItem: {type: 'hidden'}
  },
  {
    name: 'shortVideoId',
    formItem: {type: 'hidden'}
  },
  {
    name: 'screenId',
    formItem: {type: 'hidden'}
  },
  {
    title: '举报人',
    name: 'fullName',
    tableItem: {}
  },
  {
    title: '举报人帐号',
    name: 'userName',
    tableItem: {}
  },
  {
    title: '举报时间',
    name: 'operationTime',
    tableItem: {}
  },
  {
    title: '举报类型',
    name: 'type',
    tableItem: {},
    dict: [
      {code: 1, codeName: '违法违规'},
      {code: 2, codeName: '色情低俗'},
      {code: 3, codeName: '诈骗信息'},
      {code: 4, codeName: '低差广告'},
      {code: 5, codeName: '虚假不实'},
      {code: 6, codeName: '搬运抄袭'},
      {code: 7, codeName: '谩骂攻击'},
      {code: 8, codeName: '涉未成年人'},
      {code: 9, codeName: '时政不实信息'},
      {code: 10, codeName: '引人不适'},
      {code: 11, codeName: '诱导关注点赞'},
      {code: 12, codeName: '侵权投诉'},
      {code: 999, codeName: '其他'},
    ]
  },
  {
    title: '举报描述',
    name: 'remark',
    tableItem: {},
  },
  {
    title: '证据',
    name: 'files',
    tableItem: {
      render: (text, row) => (
        <WizButton disabled={!text} type='link' onClick={() => _handleLook(text)}>
          查看
        </WizButton>
      )
    }
  },
]
}

const templateConfig = (_handleLook,e) => {
  let {screenId, shortVideoId,shortVideoState} = e
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(_handleLook),
        btnAccessCheck: false,
        searchBarProps: {
          buttonSort: ['update', 'export'],
          buttons: [
            {
              key: 'update',
              custom: true,
              params: {icon: 'update', children: '处理', type: 'update'},
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: "/shortVideoScreen/record/toDeal",
                  record:{screenId, shortVideoId}
                },
              }
            },
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {
                    screenId,
                    shortVideoId,
                    ...filters
                  }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: [],
        rowOperateView: []
      }
    }
  }
};

const apis = (screenId = [], shortVideoId = []) => {
  return {
    list: {
      path: `${componentName}/recordList`,
      payload: {
        key: `${componentName}@recordList`,
        apiParams: {screenId: screenId, shortVideoId: shortVideoId}
      }
    },
    export: {
      path: `${componentName}/recordExport`,
      payload: {
        key: `${componentName}@recordExport`,
        apiParams: {screenId: screenId, shortVideoId: shortVideoId}
      }
    },
  }
}

let reduxTemplateConfig = (args) => {
  let {screenId, shortVideoId} = args
  return {
    apis: apis(screenId, shortVideoId),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
